import { motion, useReducedMotion } from "framer-motion";
import { Quote } from "lucide-react";
import { Section } from "./Section";
import { TESTIMONIALS } from "@/content/landing";

export function Testimonials() {
  const reduce = useReducedMotion();
  return (
    <Section
      id="testimonials"
      testId="landing-testimonials"
      eyebrow={TESTIMONIALS.eyebrow}
      title={TESTIMONIALS.title}
      subtitle={TESTIMONIALS.subtitle}
    >
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {TESTIMONIALS.quotes.map((q, i) => (
          <motion.figure
            key={i}
            data-testid={`testimonial-${i}`}
            initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.1 }}
            className="flex flex-col rounded-2xl border border-border/60 bg-card/50 p-7 backdrop-blur"
          >
            <Quote className="h-7 w-7 text-sema-mid/50" />
            <blockquote className="mt-4 flex-1 font-body text-[15px] leading-relaxed text-foreground/90">
              "{q.quote}"
            </blockquote>
            <figcaption className="mt-6 border-t border-border/50 pt-4">
              <div className="font-display text-sm font-semibold tracking-tight text-foreground">{q.name}</div>
              <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">{q.org}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </Section>
  );
}
